export default "/images/0fa347e35e5eb98c305d79d67535e63e.avif";